import img1 from '../images/icon/wallet.png';
import img2 from '../images/icon/shopping-cart.png';
import img3 from '../images/icon/folder.png';
import img4 from '../images/icon/money-bag.png';

const dataPortfolio = [
    {
        img: img1,
        step:'Photography',
        title : 'Caroline 2005',
        desc: 'I love my portraits and wanted you to know about the amazing response I received on LinkedIn. I have never had anyone reach out to me in the past to compliment my photo, and this year I received so many compliments. Thank you.'
    },
    {
        img: img2,
        step:'Video Production',
        title : 'Jenna 2017',
        desc: 'Jonah produced the perfect video for us. It was not only his thoughtful preparation... It was his calm and kind demeanor. His presence during the filming was never obtrusive. My staff loved him too! He captured the very essence of our program and the people in attendance. Whenever I have a need to make videos in the future, there is no doubt that I will use Jonah again.'
    },
    {
        img: img3,
        step:'Live Stream',
        title : 'John & Jen 2022',
        desc: 'We were so pleased with Jonah and the seamless streaming service he provided. We appreciated the ability to share our event with our entire communty of stakeholers. Jonah is laid-back and contributed to a relaxing atmosphere (on what could very easily have been a hectic day!) that we thoroughly enjoyed. It was a pleasure working with him! We will look to his service for many years to come.'
    },
    {
        img: img4,
        step:'Web Development',
        title : 'Victoria 2024',
        desc: 'Working with Jonah was a delight! He made me feel comfortable during the whole design and development. The unique solutions really fulfilled my needs. We are thrilled with the website. Jonah is great and I would recommend him to any of my friends.'
    },
]

export default dataPortfolio;